import React, { useState } from "react";
import Form from "rc-field-form";
import {
    Alert,
    Button,
    Col,
    Icon,
    InputNumber,
    Row,
    Select,
    Tabs,
    Tooltip
} from "antd";
import style from "./index.module.scss";
import { OtherRulesItem } from "service/score";
import icon1 from "./img/icon1.png";
import icon2 from "./img/icon2.png";
import classNames from "classnames";
const { Option } = Select;
const { TabPane } = Tabs;
interface FormListProps {
    rulesConfigObj: { title: string; type: string };
    data: OtherRulesItem[];
}

const Index = ({ rulesConfigObj, data }: FormListProps) => {
    const [collapsed, setCollapsed] = useState(true);

    return (
        <div className={style.root}>
            <div className={style.title}>
                <h4>设置计分规则</h4>
                <Button
                    className={style.exampleBtn}
                    type="link"
                    onClick={() => setCollapsed(!collapsed)}>
                    查看示例
                    <Icon
                        type={collapsed ? "down" : "up"}
                        className={style.icon}
                    />
                </Button>
            </div>
            <div className={classNames({ [style.collapse]: collapsed })}>
                <div className={style.height}>
                    <span className={style.tip1}>
                        如需分段设置成绩，请注意边界值及带小数的设置。如设置签到率90-99%，得90分
                    </span>
                    <Tabs defaultActiveKey="1">
                        <TabPane tab="示例一" key="1">
                            {icon1 && (
                                <>
                                    <span className={style.subTips}>
                                        小数向上浮动，即签到率99.5%记100分
                                    </span>
                                    <img src={icon1} alt="" />
                                </>
                            )}
                        </TabPane>
                        <TabPane tab="示例二" key="2">
                            {icon2 && (
                                <>
                                    <span className={style.subTips}>
                                        小数向下浮动，即签到率99.5%记90分
                                    </span>
                                    <img src={icon2} alt="" />
                                </>
                            )}
                        </TabPane>
                    </Tabs>
                </div>
            </div>

            <Alert
                className={style.tips}
                message={`说明：计分规则默认为空，即平台默认${rulesConfigObj.type}
                。如果添加了计分规则则按已添加的规则计算最终成绩。`}
                type="warning"
            />
            <Form.List name="otherRules" initialValue={data}>
                {(fields, { add, remove }) => (
                    <>
                        {fields.map((field, index) => (
                            <Row key={field.key} className={style.row}>
                                <Col>
                                    <Form.Field
                                        {...field}
                                        name={[field.name, "rangeVal1"]}>
                                        <InputNumber
                                            min={0}
                                            max={100}
                                            className={style.inputNumber}
                                            precision={1}
                                        />
                                    </Form.Field>
                                </Col>
                                <Tooltip
                                    placement="topLeft"
                                    title="您可尝试点击运算符后调整设置其他运算符。">
                                    <Col>
                                        <Form.Field
                                            {...field}
                                            name={[field.name, "sign1"]}>
                                            <Select
                                                allowClear
                                                showArrow={false}
                                                className={style.select}
                                                dropdownClassName={
                                                    style.option
                                                }>
                                                <Option value="0">{"<"}</Option>
                                                <Option value="1">≤</Option>
                                                {/*<Option value="2">=</Option>*/}
                                                <Option value="3">≥</Option>
                                                <Option value="4">{">"}</Option>
                                            </Select>
                                        </Form.Field>
                                    </Col>
                                </Tooltip>

                                <Col>{rulesConfigObj.title}</Col>
                                <Tooltip
                                    placement="topLeft"
                                    title="您可尝试点击运算符后调整设置其他运算符">
                                    <Col>
                                        <Form.Field
                                            {...field}
                                            name={[field.name, "sign2"]}>
                                            <Select
                                                allowClear
                                                showArrow={false}
                                                className={style.select}
                                                dropdownClassName={
                                                    style.option
                                                }>
                                                <Option value="0">{"<"}</Option>
                                                <Option value="1">≤</Option>
                                                {/*<Option value="2">=</Option>*/}
                                                <Option value="3">≥</Option>
                                                <Option value="4">{">"}</Option>
                                            </Select>
                                        </Form.Field>
                                    </Col>
                                </Tooltip>

                                <Col>
                                    <Form.Field
                                        {...field}
                                        name={[field.name, "rangeVal2"]}>
                                        <InputNumber
                                            min={0}
                                            max={100}
                                            className={style.inputNumber}
                                            precision={1}
                                        />
                                    </Form.Field>
                                </Col>
                                <Col>成绩</Col>
                                <Col>
                                    <Form.Field
                                        {...field}
                                        name={[field.name, "grade"]}>
                                        <InputNumber
                                            min={0}
                                            max={100}
                                            className={style.inputNumber}
                                            precision={1}
                                        />
                                    </Form.Field>
                                    <span> 分</span>
                                </Col>
                                <Col span={1}>
                                    <Button
                                        type="link"
                                        onClick={() => remove(index)}>
                                        <Icon type="delete" />
                                    </Button>
                                </Col>
                            </Row>
                        ))}
                        <Button
                            type="link"
                            onClick={() =>
                                add({
                                    rangeVal1: undefined,
                                    sign1: "1",
                                    rangeVal2: undefined,
                                    sign2: "0",
                                    grade: undefined
                                })
                            }
                            className={style.btn}>
                            + 新建规则
                        </Button>
                    </>
                )}
            </Form.List>
        </div>
    );
};

export default Index;
